import React from "react";

import { UserProvider } from "./UserContext";
import InitApp from "../InitApp";
import { ICIPAdminProvider } from "./ICIPAdminContext";

export const AppContext: React.FC = ({ children }) => (
  <UserProvider>
    <InitApp>
      <ICIPAdminProvider>{children}</ICIPAdminProvider>
    </InitApp>
  </UserProvider>
);
